export const POSTHOG_CONFIG = {
  api_host: "https://p.arcade.dev",
  ui_host: "https://us.posthog.com",
  capture_pageview: false,
  capture_pageleave: false,
  session_recording: {
    maskTextSelector: ".sensitive",
  },
};
